/*
 * Tea Library preorder guardrail (per-flavor box-of-4 model).
 * - Product page: a required "up to 4 weeks / possible refund" checkbox gates Add-to-Cart
 *   on library products (detected by handle). The quantity defaults to (and cannot go
 *   below) minQty, because each library flavor is sold in boxes of minQty.
 * - Cart (drawer + page): checkout is blocked unless EVERY Tea Library line item has
 *   quantity >= minQty AND consent is acknowledged. Per-flavor, NOT total: 4 Honey Rose
 *   is OK; 3 Honey Rose + 1 Spiced Apple is blocked (each flavor needs its own 4).
 * Scoped to Tea Library items only — normal products and other preorders are untouched.
 * Detection uses handles (window.DGT_TEA_LIBRARY.handles) so it never depends on the
 * sync-frozen buy-box snippet.
 */
(function () {
  'use strict';

  var CFG = window.DGT_TEA_LIBRARY || {};
  var HANDLES = CFG.handles || [];
  var MIN = CFG.minQty || 4;
  var ACK_ATTR = CFG.ackAttribute || 'Tea Library preorder acknowledged';
  var ACK_LABEL = CFG.ackLabel || 'I acknowledge this is a preorder that may take up to 4 weeks.';
  if (!HANDLES.length) return;

  var lastCart = null;

  function isLibraryHandle(h) { return !!h && HANDLES.indexOf(h) !== -1; }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function fetchCart(cb) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; if (cb) cb(c); })
      .catch(function () {});
  }
  function setAck(yes, cb) {
    var attrs = {}; attrs[ACK_ATTR] = yes ? 'Yes' : '';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; if (cb) cb(c); })
      .catch(function () {});
  }

  function libraryLines(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (it) { return isLibraryHandle(it.handle); });
  }
  function lineName(it) { return it.product_title || it.title || 'this flavor'; }
  function isAcked(cart) {
    return !!(cart && cart.attributes && String(cart.attributes[ACK_ATTR] || '') === 'Yes');
  }
  // Per-flavor gate: every library line item must reach MIN on its own.
  function evalGate(cart) {
    var lines = libraryLines(cart);
    if (!lines.length) return { blocked: false, short: [], hasLib: false, acked: true };
    var short = lines.filter(function (it) { return it.quantity < MIN; });
    var acked = isAcked(cart);
    return { blocked: short.length > 0 || !acked, short: short, hasLib: true, acked: acked };
  }

  /* ---------------- CART UI (drawer + page) ---------------- */
  var PANEL_CLASS = 'dgt-tl-panel';

  function renderCartPanels() {
    if (!lastCart) return;
    var g = evalGate(lastCart);
    var ctasList = document.querySelectorAll('.cart__ctas');
    for (var i = 0; i < ctasList.length; i++) {
      (function (ctas) {
        var host = ctas.parentNode;
        var checkoutBtn = ctas.querySelector('#checkout, [name="checkout"]');
        var panel = host.querySelector('.' + PANEL_CLASS);

        // Only render the panel when it has something to say (consent still needed,
        // or a flavor is short). When every library flavor has its 4 and consent is
        // acknowledged there's nothing to show, so remove the panel — no empty bubble.
        if (g.hasLib && (!g.acked || g.short.length)) {
          if (!panel) {
            panel = document.createElement('div');
            panel.className = PANEL_CLASS;
            host.insertBefore(panel, ctas);
          }
          var html = '';
          if (!g.acked) {
            html +=
              '<label class="dgt-tl-ack"><input type="checkbox" class="dgt-tl-ack__box">' +
              '<span>' + escapeHtml(ACK_LABEL) + '</span></label>';
          }
          if (g.short.length) {
            var parts = g.short.map(function (it) {
              return (MIN - it.quantity) + ' more ' + escapeHtml(lineName(it));
            });
            html += '<p class="dgt-tl-min">Each Tea Library flavor comes as a box of ' + MIN +
              '. Add ' + parts.join(', ') + ' to check out.</p>';
          }
          panel.innerHTML = html;
          var box = panel.querySelector('.dgt-tl-ack__box');
          if (box) {
            box.addEventListener('change', function () {
              setAck(box.checked, function () { renderCartPanels(); });
            });
          }
        } else if (panel) {
          panel.parentNode.removeChild(panel);
        }

        if (checkoutBtn) {
          if (g.blocked) {
            checkoutBtn.classList.add('dgt-tl-disabled');
            checkoutBtn.setAttribute('aria-disabled', 'true');
            checkoutBtn.setAttribute('data-dgt-tl-blocked', '1');
          } else {
            checkoutBtn.classList.remove('dgt-tl-disabled');
            checkoutBtn.removeAttribute('aria-disabled');
            checkoutBtn.removeAttribute('data-dgt-tl-blocked');
          }
        }

        // Hide the accelerated/express checkout buttons (Shop Pay, PayPal, Apple/Google
        // Pay) while blocked — they bypass the regular Checkout button and would skip the
        // 4-per-flavor gate entirely.
        var express = ctas.querySelector('.additional-checkout-buttons, .dynamic-checkout__content, shopify-accelerated-checkout-cart, shopify-accelerated-checkout');
        if (express) express.style.display = g.blocked ? 'none' : '';
      })(ctasList[i]);
    }
  }

  function flashCart() {
    var p = document.querySelector('.' + PANEL_CLASS);
    if (!p) return;
    p.classList.remove('dgt-tl-flash');
    void p.offsetWidth;
    p.classList.add('dgt-tl-flash');
    p.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Block checkout at the capture phase so it survives cart morphing / re-renders.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('#checkout, [name="checkout"]') : null;
    if (btn && evalGate(lastCart).blocked) {
      e.preventDefault(); e.stopImmediatePropagation(); flashCart();
    }
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    if (form.querySelector('#checkout, [name="checkout"]') && evalGate(lastCart).blocked) {
      e.preventDefault(); e.stopImmediatePropagation(); flashCart();
    }
  }, true);

  /* ---------------- PRODUCT PAGE ---------------- */
  var PDP_ID = 'dgt-tl-pdp-ack';
  function currentHandle() {
    var p = location.pathname.split('/products/')[1];
    return p ? p.split(/[/?#]/)[0] : null;
  }
  function initPDP() {
    if (!isLibraryHandle(currentHandle())) return;
    if (document.getElementById(PDP_ID)) return;
    var btn = document.querySelector('.dgt-buybox__add') ||
      document.querySelector('product-form-component [type="submit"]') ||
      document.querySelector('[data-type="add-to-cart-form"] [type="submit"]');
    if (!btn) return;
    // Only show the consent checkbox when the item is actually buyable (preorderable).
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var form = btn.closest('form') || document.querySelector('form[id^="DgtBuyBox-"]');

    // Mark the cart row so CSS can stack consent-above-button + hide the "Ships soon" note (library only).
    var cartRow = btn.closest('.dgt-buybox__cart-row');
    if (cartRow) cartRow.classList.add('dgt-tl-pdp-active');

    // Boxes of MIN: default the quantity to MIN and never let it drop below MIN.
    var qtyInput = (form && form.querySelector('input[name="quantity"]')) ||
      document.querySelector('input[name="quantity"]');
    if (qtyInput) {
      qtyInput.setAttribute('min', String(MIN));

      // Library items are sold as a box (quantity x unit) AND get 10% off at checkout
      // (min MIN qualifies). Show the One-Time price as the DISCOUNTED total with the
      // original struck through, both updating as the quantity changes.
      var DISCOUNT = 0.9; // 10% off — mirrors the "Tea Library 10%" automatic discount
      var otpPriceEl = document.querySelector('[data-otp-price]');
      var strikeEl = null;
      function fmtMoney(cents) {
        return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      // Insert (or re-insert, if the buy box re-rendered) the original-price strikethrough
      // right after the price, styled with the theme's existing strike class.
      function ensureStrike() {
        if (!otpPriceEl || !otpPriceEl.parentNode) return;
        if (strikeEl && strikeEl.parentNode) return;
        strikeEl = document.createElement('s');
        strikeEl.className = 'dgt-buybox__strike dgt-tl-strike';
        strikeEl.setAttribute('data-tl-original', '');
        otpPriceEl.parentNode.insertBefore(strikeEl, otpPriceEl.nextSibling);
      }
      function syncBoxPrice() {
        if (!otpPriceEl) return;
        var bb = document.querySelector('[data-dgt-buybox]');
        var unit = bb ? parseInt(bb.getAttribute('data-variant-price'), 10) : NaN;
        var q = parseInt(qtyInput.value, 10);
        if (isNaN(unit) || isNaN(q) || q < 1) return;
        var original = unit * q;
        var want = fmtMoney(Math.round(original * DISCOUNT));
        ensureStrike();
        if (strikeEl) {
          var orig = fmtMoney(original);
          if (strikeEl.textContent.trim() !== orig) strikeEl.textContent = orig;
        }
        if (otpPriceEl.textContent.trim() !== want) otpPriceEl.textContent = want;
      }

      var enforceQty = function () {
        var v = parseInt(qtyInput.value, 10);
        if (isNaN(v) || v < MIN) {
          qtyInput.value = MIN;
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        syncBoxPrice();
      };
      enforceQty();
      qtyInput.addEventListener('change', enforceQty);
      qtyInput.addEventListener('input', syncBoxPrice);
      var qtyHost = qtyInput.closest('.dgt-buybox__qty, quantity-selector, .quantity-selector') || form || document;
      qtyHost.addEventListener('click', function () { setTimeout(enforceQty, 40); });

      // Re-apply if the buy-box JS re-renders the price back to the unit price (guarded, so no loop).
      if (otpPriceEl) {
        new MutationObserver(function () { syncBoxPrice(); }).observe(otpPriceEl, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
    }

    var wrap = document.createElement('label');
    wrap.id = PDP_ID;
    wrap.className = 'dgt-tl-pdp-ack';
    wrap.innerHTML =
      '<input type="checkbox" class="dgt-tl-pdp-ack__box"><span>' + escapeHtml(ACK_LABEL) + '</span>';
    btn.parentNode.insertBefore(wrap, btn);
    var box = wrap.querySelector('.dgt-tl-pdp-ack__box');

    function sync() {
      if (box.checked) { btn.classList.remove('dgt-tl-disabled'); btn.removeAttribute('data-dgt-tl-blocked'); }
      else { btn.classList.add('dgt-tl-disabled'); btn.setAttribute('data-dgt-tl-blocked', '1'); }
    }
    // Always start UNCHECKED — the shopper must actively tick it each time (a pre-checked
    // consent box is not valid consent).
    box.addEventListener('change', function () { setAck(box.checked); sync(); });
    sync();

    function blockIfUnchecked(e) {
      if (!box.checked) {
        e.preventDefault(); e.stopImmediatePropagation();
        wrap.classList.remove('dgt-tl-flash'); void wrap.offsetWidth; wrap.classList.add('dgt-tl-flash');
      }
    }
    btn.addEventListener('click', blockIfUnchecked, true);
    if (form) form.addEventListener('submit', blockIfUnchecked, true);
  }

  /* ---------------- BOOT + OBSERVE ---------------- */
  var t = null;
  function refresh() { fetchCart(function () { renderCartPanels(); }); initPDP(); }
  function debounced() { clearTimeout(t); t = setTimeout(refresh, 150); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      var hit = (m.target && m.target.closest &&
        m.target.closest('.cart__ctas, cart-drawer, .cart-drawer, .cart, product-form-component'));
      if (!hit && m.addedNodes) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && ((n.matches && n.matches('.cart__ctas, cart-drawer, .cart-drawer, product-form-component')) ||
            (n.querySelector && n.querySelector('.cart__ctas, product-form-component')))) { hit = true; break; }
        }
      }
      if (hit) { debounced(); return; }
    }
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });

  // Re-evaluate right after any cart mutation (add / change / update / clear).
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('/cart/') !== -1 && /(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 60); }).catch(function () {});
    }
    return p;
  };

  /* ---------- Tea Library grid grouping (collection page only) ----------
   * Reorders the stock collection grid (ul.nu-grid) into sections by the product's
   * custom.library_group metafield (exposed as CFG.groups), inserting a full-width
   * heading before each group. Leaves each card untouched, so preorder add-to-cart still
   * works. Owner reassigns a flavor by changing its Library Group metafield. */
  function groupLibraryGrid() {
    if (!/\/collections\/tea-library(\/|$|\?|#)/.test(location.pathname)) return;
    // The stock grid forces fixed-height rows, so a heading placed INSIDE it gets a full
    // card-height row (huge gap). Instead split the one grid into one grid per group, with
    // each heading as a plain <h2> sibling between them.
    var grid = document.querySelector('ul.nu-grid:not([data-dgt-grouped])');
    if (!grid || !grid.parentElement) return;
    var items = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.tagName === 'LI' && el.querySelector && el.querySelector('a[href*="/products/"]');
    });
    if (items.length < 2) return;
    var groups = CFG.groups || {};
    var order = CFG.groupOrder || [];
    if (!Object.keys(groups).length) return; // no group data yet — leave the grid as-is
    function handleOf(li) {
      var a = li.querySelector('a[href*="/products/"]');
      if (!a) return '';
      var seg = a.getAttribute('href').split('/products/')[1];
      return seg ? seg.split('?')[0].split('#')[0].split('/')[0] : '';
    }
    var byGroup = {};
    items.forEach(function (li) {
      var g = groups[handleOf(li)] || 'Specialty';
      (byGroup[g] = byGroup[g] || []).push(li);
    });
    var ordered = order.slice();
    Object.keys(byGroup).forEach(function (g) { if (ordered.indexOf(g) === -1) ordered.push(g); });

    // Alphabetise the flavors within each category.
    function titleOf(li) {
      var links = li.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < links.length; i++) {
        var t = (links[i].textContent || '').replace(/\s+/g, ' ').trim();
        if (t) return t.toLowerCase();
      }
      var img = li.querySelector('img[alt]');
      return img ? (img.getAttribute('alt') || '').toLowerCase() : handleOf(li);
    }
    Object.keys(byGroup).forEach(function (g) {
      byGroup[g].sort(function (a, b) { return titleOf(a).localeCompare(titleOf(b)); });
    });

    grid.setAttribute('data-dgt-grouped', '1');
    var parent = grid.parentElement;
    var gridClass = grid.className;
    var frag = document.createDocumentFragment();
    ordered.forEach(function (g) {
      var list = byGroup[g];
      if (!list || !list.length) return;
      var head = document.createElement('h2');
      head.className = 'dgt-tl-group-head';
      head.textContent = g;
      frag.appendChild(head);
      var ul = document.createElement('ul');
      ul.className = gridClass;
      ul.setAttribute('data-dgt-grouped', '1');
      list.forEach(function (li) { ul.appendChild(li); });
      frag.appendChild(ul);
    });
    parent.insertBefore(frag, grid);
    if (grid.parentNode) grid.parentNode.removeChild(grid);
  }

  function bootGroup() {
    var tries = 0;
    (function attempt() {
      groupLibraryGrid();
      var grid = document.querySelector('ul.nu-grid');
      if ((!grid || grid.getAttribute('data-dgt-grouped') !== '1') && tries++ < 10) { setTimeout(attempt, 250); return; }
      if (grid && grid.parentElement && !grid.parentElement.__dgtLibObs) {
        grid.parentElement.__dgtLibObs = true;
        // Re-group when the grid is replaced (e.g. after a sort change).
        new MutationObserver(function () { setTimeout(groupLibraryGrid, 40); }).observe(grid.parentElement, { childList: true });
      }
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootGroup);
  else bootGroup();
})();
